var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Hind:300,400,500,600,700);", ""]);

// module
exports.push([module.id, "@font-face{font-family:letter-gothic;font-style:normal;font-weight:300;src:local(\"Letter Gothic\"),local(\"letter-gothic\"),url(" + escape(require("./letter-gothic-std.woff2")) + ") format(\"woff2\")}@font-face{font-family:letter-gothic;font-style:normal;font-weight:900;src:local(\"Letter Gothic Bold\"),local(\"letter-gothic-bold\"),url(" + escape(require("./letter-gothic-std-bold.woff2")) + ") format(\"woff2\")}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/assets/fonts/font.css
// module id = 4
// module chunks = 164